// 订单分享 - 按需加载模块

const orderMove = resolve => {
  require.ensure(
    [],
    () => {
      resolve(require('../../components/order-share/move.vue'));
    },
    'order-share',
  );
};

// 前端路由
export default [
  {
    path: '/order-share/move',
    component: orderMove,
    meta: {
      title: '货拉拉订单',
    },
  },
];
